// Listing data for the /services index page. Each entry maps to a real
// route under /services/:slug.

export const SERVICE_PAGES = [
  {
    slug: "wilmington",
    path: "/services/wilmington",
    city: "Wilmington, NC",
    county: "New Hanover County",
    title: "Commercial Restroom Sanitation Cleaning in Wilmington",
    description:
      "Deep cleaning solutions for offices, retail, medical, restaurants, schools, warehouses and industrial properties. Hospital-grade disinfectants, deep-foam technology, and detail-oriented technicians built for Wilmington facilities.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_deep-hygiene/artifacts/ehk68r2n_Commercial%20Cleaning.png",
    coverAlt:
      "Cleaning technician in yellow rubber glove wiping a chrome restroom faucet",
    highlights: [
      "Deep Foam Cleaning",
      "Sanitization & Disinfection",
      "Odor Removal",
      "Maintenance Programs",
    ],
  },
  {
    slug: "wrightsville-beach",
    path: "/services/wrightsville-beach",
    city: "Wrightsville Beach, NC",
    county: "New Hanover County",
    title: "Commercial Restroom Cleaning & Sanitation in Wrightsville Beach",
    description:
      "Foam restroom sanitation, pressure washing, urine odor removal, and commercial disinfecting built for high-traffic beach, hospitality, and coastal facilities across Wrightsville Beach and the Cape Fear region.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_deep-hygiene/artifacts/bptznbfo_St.%20Petersburg%20Restroom%20Cleaning.png",
    coverAlt:
      "Coastal waterfront skyline representing Wrightsville Beach, NC",
    highlights: [
      "Deep Foam Sanitation",
      "Pressure Washing",
      "Urine Odor Removal",
      "Disinfection & Germ Control",
    ],
  },
  {
    slug: "carolina-beach",
    path: "/services/carolina-beach",
    city: "Carolina Beach, NC",
    county: "New Hanover County",
    title: "Seven Layers of Restroom Sanitation in Carolina Beach",
    description:
      "Complete seven-layer restroom sanitation program for Carolina Beach businesses — hospital-grade disinfection, foam cleaning, descaling, odor control, high-touch sanitation, and tailored maintenance plans.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_deep-hygiene/artifacts/rcjff4zo_Clearwater%20Bathroom.png",
    coverAlt:
      "Clean white commercial toilet beside a bucket of cleaning supplies on a bathroom floor",
    highlights: [
      "Hospital-Grade Disinfection",
      "Foam & Pressure Washing",
      "Urinal & Toilet Descaling",
      "High-Touch Sanitation",
    ],
  },
  {
    slug: "surf-city",
    path: "/services/surf-city",
    city: "Surf City, NC",
    county: "New Hanover & Pender Counties",
    title: "The Impact of Dirty Toilets in Surf City & Topsail Beach",
    description:
      "Dirty toilets are a health risk. Professional commercial restroom sanitation across Surf City, Topsail Beach, Hampstead, and the Cape Fear Coast — eliminating bacteria, odors, and the hidden business impact of unclean restrooms.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_deep-hygiene/artifacts/0sf5x9d8_Toliet%20Cleaning%20Sarasota.png",
    coverAlt:
      "Gloved hand scrubbing a clean white toilet bowl with a sponge in a bright residential bathroom",
    highlights: [
      "Hospital-Grade Disinfecting",
      "Deep Foam Cleaning",
      "Odor & Urine Treatment",
      "Tile & Grout Cleaning",
    ],
  },
  {
    slug: "professional-restroom-cleaning",
    path: "/services/professional-restroom-cleaning",
    city: "Wilmington, NC",
    county: "Cape Fear Region",
    title: "Why Professional Restroom Cleaning Matters for Wilmington Businesses",
    description:
      "Wilmington, NC's specialist in commercial restroom cleaning — restaurants, gas stations, retail, gyms, offices, and beach-area businesses across Wrightsville Beach, Carolina Beach, Kure Beach, Leland, Hampstead, and the greater Cape Fear region. 7 Layers of Clean. Local. Fully insured.",
    coverImage:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_deep-hygiene/artifacts/zint4arm_Restroom%20Sings.png.webp",
    coverAlt:
      "Clean commercial restroom with row of sinks, mirrors, and stainless paper towel dispensers",
    highlights: [
      "7 Layers of Clean",
      "One-Time Deep Cleans",
      "Recurring Maintenance",
      "Fully Insured & Local",
    ],
  },
];
